var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useAnimatedStyle = useAnimatedStyle;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = require("react");
var _core = require("../core");
var _UpdateProps = _interopRequireWildcard(require("../UpdateProps"));
var _animation = require("../animation");
var _NativeReanimated = _interopRequireDefault(require("../NativeReanimated"));
var _useSharedValue = require("./useSharedValue");
var _utils = require("./utils");
var _ViewDescriptorsSet = require("../ViewDescriptorsSet");
var _PlatformChecker = require("../PlatformChecker");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
var _worklet_9845906137963_init_data = {
    code: "function prepareAnimation(frameTimestamp,animatedProp,lastAnimation,lastValue){const prepareAnimation=this._recur;if(Array.isArray(animatedProp)){animatedProp.forEach(function(prop,index){prepareAnimation(frameTimestamp,prop,lastAnimation&&lastAnimation[index],lastValue&&lastValue[index]);});}if(typeof animatedProp==='object'&&animatedProp.onFrame){const animation=animatedProp;let value=animation.current;if(lastValue!==undefined){if(typeof lastValue==='object'){if(lastValue.value!==undefined){value=lastValue.value;}else if(lastValue.onFrame!==undefined){if((lastAnimation===null||lastAnimation===void 0?void 0:lastAnimation.current)!==undefined){value=lastAnimation.current;}else if((lastValue===null||lastValue===void 0?void 0:lastValue.current)!==undefined){value=lastValue.current;}}}else{value=lastValue;}}animation.callStart=function(timestamp){animation.onStart(animation,value,timestamp,lastAnimation);};animation.callStart(frameTimestamp);animation.callStart=null;}else if(typeof animatedProp==='object'){Object.keys(animatedProp).forEach(function(key){return prepareAnimation(frameTimestamp,animatedProp[key],lastAnimation&&lastAnimation[key],lastValue&&lastValue[key]);});}}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedStyle.ts",
    sourceMap: '{"version":3,"names":["prepareAnimation","frameTimestamp","animatedProp","lastAnimation","lastValue","_recur","Array","isArray","forEach","prop","index","onFrame","animation","value","current","undefined","callStart","timestamp","onStart","Object","keys","key"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedStyle.ts"],"mappings":"AA6CA,SAAAA,gBAASA,CACPC,cAAA,CAAsBC,YACtB,CAAgCC,aAChC,CAAiCC,SACjC,CACD,OAAAJ,gBAAA,MAAAK,MAAA,CAEC,GAAIC,KAAK,CAACC,OAAO,CAACL,YAAY,CAAC,CAAE,CAC/BA,YAAY,CAACM,OAAO,CAAC,SAACC,IAAI,CAAEC,KAAK,CAAK,CACpCV,gBAAgB,CACdC,cAAc,CACdQ,IAAI,CACJN,aAAa,EAAIA,aAAa,CAACO,KAAK,CAAC,CACrCN,SAAS,EAAIA,SAAS,CAACM,KAAK,CAC9B,CAAC,CACH,CAAC,CAAC,CAEJ,CACA,GAAI,MAAO,CAAAR,YAAY,GAAK,QAAQ,EAAIA,YAAY,CAACS,OAAO,CAAE,CAC5D,KAAM,CAAAC,SAAS,CAAGV,YAAY,CAE9B,GAAI,CAAAW,KAAK,CAAGD,SAAS,CAACE,OAAO,CAC7B,GAAIV,SAAS,GAAKW,SAAS,CAAE,CAC3B,GAAI,MAAO,CAAAX,SAAS,GAAK,QAAQ,CAAE,CACjC,GAAIA,SAAS,CAACS,KAAK,GAAKE,SAAS,CAAE,CAEjCF,KAAK,CAAGT,SAAS,CAACS,KAAK,CACzB,CAAC,IAAM,IAAIT,SAAS,CAACO,OAAO,GAAKI,SAAS,CAAE,CAC1C,GAAI,CAAAZ,aAAa,SAAbA,aAAa,iBAAbA,aAAa,CAAEW,OAAO,IAAKC,SAAS,CAAE,CAExCF,KAAK,CAAGV,aAAa,CAACW,OAAO,CAC/B,CAAC,IAAM,IAAI,CAAAV,SAAS,SAATA,SAAS,iBAATA,SAAS,CAAEU,OAAO,IAAKC,SAAS,CAAE,CAE3CF,KAAK,CAAGT,SAAS,CAACU,OAAO,CAC3B,CACF,CACF,CAAC,IAAM,CAELD,KAAK,CAAGT,SAAS,CACnB,CACF,CAEAQ,SAAS,CAACI,SAAS,CAAG,SAACC,SAAoB,CAAK,CAC9CL,SAAS,CAACM,OAAO,CAACN,SAAS,CAAEC,KAAK,CAAEI,SAAS,CAAEd,aAAa,CAAC,CAC/D,CAAC,CACDS,SAAS,CAACI,SAAS,CAACf,cAAc,CAAC,CACnCW,SAAS,CAACI,SAAS,CAAG,IAAI,CAC5B,CAAC,IAAM,IAAI,MAAO,CAAAd,YAAY,GAAK,QAAQ,CAAE,CAE3CiB,MAAM,CAACC,IAAI,CAAClB,YAAY,CAAC,CAACM,OAAO,CAAE,SAAAa,GAAG,QACpC,CAAArB,gBAAgB,CACdC,cAAc,CACdC,YAAY,CAACmB,GAAG,CAAC,CACjBlB,aAAa,EAAIA,aAAa,CAACkB,GAAG,CAAC,CACnCjB,SAAS,EAAIA,SAAS,CAACiB,GAAG,CAC5B,CACF,GAAC,CACH,CACF"}',
    version: "3.5.4"
};
var prepareAnimation = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var prepareAnimation = function prepareAnimation(frameTimestamp, animatedProp, lastAnimation, lastValue) {
        if (Array.isArray(animatedProp)) {
            animatedProp.forEach(function(prop, index) {
                prepareAnimation(frameTimestamp, prop, lastAnimation && lastAnimation[index], lastValue && lastValue[index]);
            });
        }
        if (typeof animatedProp === "object" && animatedProp.onFrame) {
            var animation = animatedProp;
            var value = animation.current;
            if (lastValue !== undefined) {
                if (typeof lastValue === "object") {
                    if (lastValue.value !== undefined) {
                        value = lastValue.value;
                    } else if (lastValue.onFrame !== undefined) {
                        if ((lastAnimation == null ? void 0 : lastAnimation.current) !== undefined) {
                            value = lastAnimation.current;
                        } else if ((lastValue == null ? void 0 : lastValue.current) !== undefined) {
                            value = lastValue.current;
                        }
                    }
                } else {
                    value = lastValue;
                }
            }
            animation.callStart = function(timestamp) {
                animation.onStart(animation, value, timestamp, lastAnimation);
            };
            animation.callStart(frameTimestamp);
            animation.callStart = null;
        } else if (typeof animatedProp === "object") {
            Object.keys(animatedProp).forEach(function(key) {
                return prepareAnimation(frameTimestamp, animatedProp[key], lastAnimation && lastAnimation[key], lastValue && lastValue[key]);
            });
        }
    };
    prepareAnimation.__closure = {};
    prepareAnimation.__initData = _worklet_9845906137963_init_data;
    prepareAnimation.__workletHash = 9845906137963;
    prepareAnimation.__stackDetails = _e;
    return prepareAnimation;
}();
var _worklet_2202010840260_init_data = {
    code: "function runAnimations(animation,timestamp,key,result,animationsActive){const runAnimations=this._recur;if(!animationsActive.value){return true;}if(Array.isArray(animation)){result[key]=[];let allFinished=true;animation.forEach(function(entry,index){if(!runAnimations(entry,timestamp,index,result[key],animationsActive)){allFinished=false;}});return allFinished;}else if(typeof animation==='object'&&animation.onFrame){let finished=true;if(!animation.finished){if(animation.callStart){animation.callStart(timestamp);animation.callStart=null;}finished=animation.onFrame(animation,timestamp);animation.timestamp=timestamp;if(finished){animation.finished=true;animation.callback&&animation.callback(true);}}result[key]=animation.current;return finished;}else if(typeof animation==='object'){result[key]={};let allFinished=true;Object.keys(animation).forEach(function(k){if(!runAnimations(animation[k],timestamp,k,result[key],animationsActive)){allFinished=false;}});return allFinished;}else{result[key]=animation;return true;}}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedStyle.ts",
    sourceMap: '{"version":3,"names":["runAnimations","animation","timestamp","key","result","animationsActive","_recur","value","Array","isArray","allFinished","forEach","entry","index","onFrame","finished","callStart","callback","current","Object","keys","k"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedStyle.ts"],"mappings":"AAyGA,SAAAA,aAASA,CACPC,SAAA,CAA6BC,SAC7B,CAAoBC,GACpB,CAAoBC,MACpB,CAA0BC,gBAC1B,CACD,OAAAL,aAAA,MAAAM,MAAA,CAEC,GAAI,CAACD,gBAAgB,CAACE,KAAK,CAAE,CAC3B,MAAO,KAAI,CACb,CACA,GAAIC,KAAK,CAACC,OAAO,CAACR,SAAS,CAAC,CAAE,CAC5BG,MAAM,CAACD,GAAG,CAAC,CAAG,EAAE,CAChB,GAAI,CAAAO,WAAW,CAAG,IAAI,CACtBT,SAAS,CAACU,OAAO,CAAC,SAACC,KAAK,CAAEC,KAAK,CAAK,CAClC,GACE,CAACb,aAAa,CAACY,KAAK,CAAEV,SAAS,CAAEW,KAAK,CAAET,MAAM,CAACD,GAAG,CAAC,CAAEE,gBAAgB,CAAC,CACtE,CACAK,WAAW,CAAG,KAAK,CACrB,CACF,CAAC,CAAC,CACF,MAAO,CAAAA,WAAW,CACpB,CAAC,IAAM,IAAI,MAAO,CAAAT,SAAS,GAAK,QAAQ,EAAIA,SAAS,CAACa,OAAO,CAAE,CAC7D,GAAI,CAAAC,QAAQ,CAAG,IAAI,CACnB,GAAI,CAACd,SAAS,CAACc,QAAQ,CAAE,CACvB,GAAId,SAAS,CAACe,SAAS,CAAE,CACvBf,SAAS,CAACe,SAAS,CAACd,SAAS,CAAC,CAC9BD,SAAS,CAACe,SAAS,CAAG,IAAI,CAC5B,CACAD,QAAQ,CAAGd,SAAS,CAACa,OAAO,CAACb,SAAS,CAAEC,SAAS,CAAC,CAClDD,SAAS,CAACC,SAAS,CAAGA,SAAS,CAC/B,GAAIa,QAAQ,CAAE,CACZd,SAAS,CAACc,QAAQ,CAAG,IAAI,CACzBd,SAAS,CAACgB,QAAQ,EAAIhB,SAAS,CAACgB,QAAQ,CAAC,IAAmB,CAAC,CAC/D,CACF,CACAb,MAAM,CAACD,GAAG,CAAC,CAAGF,SAAS,CAACiB,OAAO,CAC/B,MAAO,CAAAH,QAAQ,CACjB,CAAC,IAAM,IAAI,MAAO,CAAAd,SAAS,GAAK,QAAQ,CAAE,CACxCG,MAAM,CAACD,GAAG,CAAC,CAAG,CAAC,CAAC,CAChB,GAAI,CAAAO,WAAW,CAAG,IAAI,CACtBS,MAAM,CAACC,IAAI,CAACnB,SAAS,CAAC,CAACU,OAAO,CAAE,SAAAU,CAAC,CAAK,CACpC,GACE,CAACrB,aAAa,CACZC,SAAS,CAACoB,CAAC,CAAC,CACZnB,SAAS,CACTmB,CAAC,CACDjB,MAAM,CAACD,GAAG,CAAC,CACXE,gBACF,CAAC,CACD,CACAK,WAAW,CAAG,KAAK,CACrB,CACF,CAAC,CAAC,CACF,MAAO,CAAAA,WAAW,CACpB,CAAC,IAAM,CACLN,MAAM,CAACD,GAAG,CAAC,CAAGF,SAAS,CACvB,MAAO,KAAI,CACb,CACF"}',
    version: "3.5.4"
};
var runAnimations = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var runAnimations = function runAnimations(animation, timestamp, key, result, animationsActive) {
        if (!animationsActive.value) {
            return true;
        }
        if (Array.isArray(animation)) {
            result[key] = [];
            var allFinished = true;
            animation.forEach(function(entry, index) {
                if (!runAnimations(entry, timestamp, index, result[key], animationsActive)) {
                    allFinished = false;
                }
            });
            return allFinished;
        } else if (typeof animation === "object" && animation.onFrame) {
            var finished = true;
            if (!animation.finished) {
                if (animation.callStart) {
                    animation.callStart(timestamp);
                    animation.callStart = null;
                }
                finished = animation.onFrame(animation, timestamp);
                animation.timestamp = timestamp;
                if (finished) {
                    animation.finished = true;
                    animation.callback && animation.callback(true);
                }
            }
            result[key] = animation.current;
            return finished;
        } else if (typeof animation === "object") {
            result[key] = {};
            var _allFinished = true;
            Object.keys(animation).forEach(function(k) {
                if (!runAnimations(animation[k], timestamp, k, result[key], animationsActive)) {
                    _allFinished = false;
                }
            });
            return _allFinished;
        } else {
            result[key] = animation;
            return true;
        }
    };
    runAnimations.__closure = {};
    runAnimations.__initData = _worklet_2202010840260_init_data;
    runAnimations.__workletHash = 2202010840260;
    runAnimations.__stackDetails = _e;
    return runAnimations;
}();
var _worklet_7185925414587_init_data = {
    code: "function styleUpdater(viewDescriptors,updater,state,maybeViewRef,animationsActive,isAnimatedProps=false){const{isAnimated,prepareAnimation,runAnimations,updateProps,shallowEqual}=this.__closure;var _state$animations,_updater;const animations=(_state$animations=state.animations)!==null&&_state$animations!==void 0?_state$animations:{};const newValues=(_updater=updater())!==null&&_updater!==void 0?_updater:{};const oldValues=state.last;const nonAnimatedNewValues={};let hasAnimations=false;let frameTimestamp;let hasNonAnimatedValues=false;for(const key in newValues){const value=newValues[key];if(isAnimated(value)){frameTimestamp=global.__frameTimestamp||performance.now();prepareAnimation(frameTimestamp,value,animations[key],oldValues[key]);animations[key]=value;hasAnimations=true;}else{hasNonAnimatedValues=true;nonAnimatedNewValues[key]=value;delete animations[key];}}if(hasAnimations){const frame=function(timestamp){const{animations:animations,last:last,isAnimationCancelled:isAnimationCancelled}=state;if(isAnimationCancelled){state.isAnimationRunning=false;return;}const updates={};let allFinished=true;for(const propName in animations){const finished=runAnimations(animations[propName],timestamp,propName,updates,animationsActive);if(finished){last[propName]=updates[propName];delete animations[propName];}else{allFinished=false;}}if(updates){updateProps(viewDescriptors,updates,maybeViewRef);}if(!allFinished){requestAnimationFrame(frame);}else{state.isAnimationRunning=false;}};state.animations=animations;if(!state.isAnimationRunning){state.isAnimationCancelled=false;state.isAnimationRunning=true;frame(frameTimestamp);}if(hasNonAnimatedValues){updateProps(viewDescriptors,nonAnimatedNewValues,maybeViewRef);}}else{state.isAnimationCancelled=true;state.animations=[];if(!shallowEqual(oldValues,newValues)){updateProps(viewDescriptors,newValues,maybeViewRef,isAnimatedProps);}}state.last=newValues;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedStyle.ts",
    sourceMap: '{"version":3,"names":["styleUpdater","viewDescriptors","updater","state","maybeViewRef","animationsActive","isAnimatedProps","isAnimated","prepareAnimation","runAnimations","updateProps","shallowEqual","__closure","_state$animations","_updater","animations","newValues","oldValues","last","nonAnimatedNewValues","hasAnimations","frameTimestamp","hasNonAnimatedValues","key","value","global","__frameTimestamp","performance","now","frame","timestamp","isAnimationCancelled","isAnimationRunning","updates","allFinished","propName","finished","requestAnimationFrame"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedStyle.ts"],"mappings":"AAsKA,SAAAA,YAASA,CACPC,eAAA,CAA0CC,OAC1C,CAAmDC,KACnD,CAAoBC,YACpB,CAAyCC,gBACzC,CAAsCC,eACtC,CAAe,KAAG,CACnB,OAAAC,UAAA,CAAAC,gBAAA,CAAAC,aAAA,CAAAC,WAAA,CAAAC,YAAA,OAAAC,SAAA,CAAO,IAAAC,iBAAA,CAAAC,QAAA,CAEN,KAAM,CAAAC,UAAU,EAAAF,iBAAA,CAAGV,KAAK,CAACY,UAAU,UAAAF,iBAAA,UAAAA,iBAAA,CAAI,CAAC,CAAC,CACzC,KAAM,CAAAG,SAAS,EAAAF,QAAA,CAAGZ,OAAO,CAAC,CAAC,UAAAY,QAAA,UAAAA,QAAA,CAAI,CAAC,CAAC,CACjC,KAAM,CAAAG,SAAS,CAAGd,KAAK,CAACe,IAAI,CAC5B,KAAM,CAAAC,oBAAgC,CAAG,CAAC,CAAC,CAE3C,GAAI,CAAAC,aAAa,CAAG,KAAK,CACzB,GAAI,CAAAC,cAAkC,CACtC,GAAI,CAAAC,oBAAoB,CAAG,KAAK,CAChC,IAAK,KAAM,CAAAC,GAAG,GAAI,CAAAP,SAAS,CAAE,CAC3B,KAAM,CAAAQ,KAAK,CAAGR,SAAS,CAACO,GAAG,CAAC,CAC5B,GAAIhB,UAAU,CAACiB,KAAK,CAAC,CAAE,CACrBH,cAAc,CAAGI,MAAM,CAACC,gBAAgB,EAAIC,WAAW,CAACC,GAAG,CAAC,CAAC,CAC7DpB,gBAAgB,CAACa,cAAc,CAAEG,KAAK,CAAET,UAAU,CAACQ,GAAG,CAAC,CAAEN,SAAS,CAACM,GAAG,CAAC,CAAC,CACxER,UAAU,CAACQ,GAAG,CAAC,CAAGC,KAAK,CACvBJ,aAAa,CAAG,IAAI,CACtB,CAAC,IAAM,CACLE,oBAAoB,CAAG,IAAI,CAC3BH,oBAAoB,CAACI,GAAG,CAAC,CAAGC,KAAK,CACjC,MAAO,CAAAT,UAAU,CAACQ,GAAG,CAAC,CACxB,CACF,CAEA,GAAIH,aAAa,CAAE,CACjB,KAAM,CAAAS,KAAK,CAAG,QAAAA,CAACC,SAAoB,CAAK,CACtC,KAAM,CAAEf,UAAU,CAAVA,UAAU,CAAEG,IAAI,CAAJA,IAAI,CAAEa,oBAAA,CAAAA,oBAAqB,CAAC,CAAG5B,KAAK,CACxD,GAAI4B,oBAAoB,CAAE,CACxB5B,KAAK,CAAC6B,kBAAkB,CAAG,KAAK,CAChC,OACF,CAEA,KAAM,CAAAC,OAA2B,CAAG,CAAC,CAAC,CACtC,GAAI,CAAAC,WAAW,CAAG,IAAI,CACtB,IAAK,KAAM,CAAAC,QAAQ,GAAI,CAAApB,UAAU,CAAE,CACjC,KAAM,CAAAqB,QAAQ,CAAG3B,aAAa,CAC5BM,UAAU,CAACoB,QAAQ,CAAC,CACpBL,SAAS,CACTK,QAAQ,CACRF,OAAO,CACP5B,gBACF,CAAC,CACD,GAAI+B,QAAQ,CAAE,CACZlB,IAAI,CAACiB,QAAQ,CAAC,CAAGF,OAAO,CAACE,QAAQ,CAAC,CAClC,MAAO,CAAApB,UAAU,CAACoB,QAAQ,CAAC,CAC7B,CAAC,IAAM,CACLD,WAAW,CAAG,KAAK,CACrB,CACF,CAEA,GAAID,OAAO,CAAE,CACXvB,WAAW,CAACT,eAAe,CAAEgC,OAAO,CAAE7B,YAAY,CAAC,CACrD,CAEA,GAAI,CAAC8B,WAAW,CAAE,CAChBG,qBAAqB,CAACR,KAAK,CAAC,CAC9B,CAAC,IAAM,CACL1B,KAAK,CAAC6B,kBAAkB,CAAG,KAAK,CAClC,CACF,CAAC,CAED7B,KAAK,CAACY,UAAU,CAAGA,UAAU,CAC7B,GAAI,CAACZ,KAAK,CAAC6B,kBAAkB,CAAE,CAC7B7B,KAAK,CAAC4B,oBAAoB,CAAG,KAAK,CAClC5B,KAAK,CAAC6B,kBAAkB,CAAG,IAAI,CAC/BH,KAAK,CAACR,cAAe,CAAC,CACxB,CAEA,GAAIC,oBAAoB,CAAE,CACxBZ,WAAW,CAACT,eAAe,CAAEkB,oBAAoB,CAAEf,YAAY,CAAC,CAClE,CACF,CAAC,IAAM,CACLD,KAAK,CAAC4B,oBAAoB,CAAG,IAAI,CACjC5B,KAAK,CAACY,UAAU,CAAG,EAAE,CAErB,GAAI,CAACJ,YAAY,CAACM,SAAS,CAAED,SAAS,CAAC,CAAE,CACvCN,WAAW,CAACT,eAAe,CAAEe,SAAS,CAAEZ,YAAY,CAAEE,eAAe,CAAC,CACxE,CACF,CACAH,KAAK,CAACe,IAAI,CAAGF,SAAS,CACxB"}',
    version: "3.5.4"
};
var styleUpdater = function() {
    var _e = [
        new global.Error(),
        -6,
        -27
    ];
    var styleUpdater = function styleUpdater(viewDescriptors, updater, state, maybeViewRef, animationsActive) {
        var _state$animations, _updater;
        var isAnimatedProps = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
        var animations = (_state$animations = state.animations) != null ? _state$animations : {};
        var newValues = (_updater = updater()) != null ? _updater : {};
        var oldValues = state.last;
        var nonAnimatedNewValues = {};
        var hasAnimations = false;
        var frameTimestamp;
        var hasNonAnimatedValues = false;
        for(var key in newValues){
            var value = newValues[key];
            if ((0, _utils.isAnimated)(value)) {
                frameTimestamp = global.__frameTimestamp || performance.now();
                prepareAnimation(frameTimestamp, value, animations[key], oldValues[key]);
                animations[key] = value;
                hasAnimations = true;
            } else {
                hasNonAnimatedValues = true;
                nonAnimatedNewValues[key] = value;
                delete animations[key];
            }
        }
        if (hasAnimations) {
            var frame = function frame(timestamp) {
                var animations = state.animations, last = state.last, isAnimationCancelled = state.isAnimationCancelled;
                if (isAnimationCancelled) {
                    state.isAnimationRunning = false;
                    return;
                }
                var updates = {};
                var allFinished = true;
                for(var propName in animations){
                    var finished = runAnimations(animations[propName], timestamp, propName, updates, animationsActive);
                    if (finished) {
                        last[propName] = updates[propName];
                        delete animations[propName];
                    } else {
                        allFinished = false;
                    }
                }
                if (updates) {
                    (0, _UpdateProps.default)(viewDescriptors, updates, maybeViewRef);
                }
                if (!allFinished) {
                    requestAnimationFrame(frame);
                } else {
                    state.isAnimationRunning = false;
                }
            };
            state.animations = animations;
            if (!state.isAnimationRunning) {
                state.isAnimationCancelled = false;
                state.isAnimationRunning = true;
                frame(frameTimestamp);
            }
            if (hasNonAnimatedValues) {
                (0, _UpdateProps.default)(viewDescriptors, nonAnimatedNewValues, maybeViewRef);
            }
        } else {
            state.isAnimationCancelled = true;
            state.animations = [];
            if (!(0, _utils.shallowEqual)(oldValues, newValues)) {
                (0, _UpdateProps.default)(viewDescriptors, newValues, maybeViewRef, isAnimatedProps);
            }
        }
        state.last = newValues;
    };
    styleUpdater.__closure = {
        isAnimated: _utils.isAnimated,
        prepareAnimation: prepareAnimation,
        runAnimations: runAnimations,
        updateProps: _UpdateProps.default,
        shallowEqual: _utils.shallowEqual
    };
    styleUpdater.__initData = _worklet_7185925414587_init_data;
    styleUpdater.__workletHash = 7185925414587;
    styleUpdater.__stackDetails = _e;
    return styleUpdater;
}();
var _worklet_9683044866140_init_data = {
    code: "function jestStyleUpdater(viewDescriptors,updater,state,maybeViewRef,animationsActive,animatedStyle,adapters=[]){const{isAnimated,prepareAnimation,runAnimations,updatePropsJestWrapper,shallowEqual}=this.__closure;var _state$animations,_updater;const animations=(_state$animations=state.animations)!==null&&_state$animations!==void 0?_state$animations:{};const newValues=(_updater=updater())!==null&&_updater!==void 0?_updater:{};const oldValues=state.last;let hasAnimations=false;let frameTimestamp;Object.keys(animations).forEach(function(key){const value=newValues[key];if(!isAnimated(value)){delete animations[key];}});Object.keys(newValues).forEach(function(key){const value=newValues[key];if(isAnimated(value)){frameTimestamp=global.__frameTimestamp||performance.now();prepareAnimation(frameTimestamp,value,animations[key],oldValues[key]);animations[key]=value;hasAnimations=true;}});function frame(timestamp){const{animations:animations,last:last,isAnimationCancelled:isAnimationCancelled}=state;if(isAnimationCancelled){state.isAnimationRunning=false;return;}const updates={};let allFinished=true;Object.keys(animations).forEach(function(propName){const finished=runAnimations(animations[propName],timestamp,propName,updates,animationsActive);if(finished){last[propName]=updates[propName];delete animations[propName];}else{allFinished=false;}});if(Object.keys(updates).length){updatePropsJestWrapper(viewDescriptors,updates,maybeViewRef,animatedStyle,adapters);}if(!allFinished){requestAnimationFrame(frame);}else{state.isAnimationRunning=false;}}if(hasAnimations){state.animations=animations;if(!state.isAnimationRunning){state.isAnimationCancelled=false;state.isAnimationRunning=true;frame(frameTimestamp);}}else{state.isAnimationCancelled=true;state.animations=[];}state.last=newValues;if(!shallowEqual(oldValues,newValues)){updatePropsJestWrapper(viewDescriptors,newValues,maybeViewRef,animatedStyle,adapters);}}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedStyle.ts",
    sourceMap: '{"version":3,"names":["jestStyleUpdater","viewDescriptors","updater","state","maybeViewRef","animationsActive","animatedStyle","adapters","isAnimated","prepareAnimation","runAnimations","updatePropsJestWrapper","shallowEqual","__closure","_state$animations","_updater","animations","newValues","oldValues","last","hasAnimations","frameTimestamp","Object","keys","forEach","key","value","global","__frameTimestamp","performance","now","frame","timestamp","isAnimationCancelled","isAnimationRunning","updates","allFinished","propName","finished","length","requestAnimationFrame"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedStyle.ts"],"mappings":"AA+PA,SAAAA,gBAASA,CACPC,eAAA,CAA0CC,OAC1C,CAAmDC,KACnD,CAAoBC,YACpB,CAAyCC,gBACzC,CAAsCC,aACtC,CAAmDC,QACnD,CAAoC,EAAG,CACxC,OAAAC,UAAA,CAAAC,gBAAA,CAAAC,aAAA,CAAAC,sBAAA,CAAAC,YAAA,OAAAC,SAAA,CAAO,IAAAC,iBAAA,CAAAC,QAAA,CAEN,KAAM,CAAAC,UAA8B,EAAAF,iBAAA,CAAGX,KAAK,CAACa,UAAU,UAAAF,iBAAA,UAAAA,iBAAA,CAAI,CAAC,CAAC,CAC7D,KAAM,CAAAG,SAAS,EAAAF,QAAA,CAAGb,OAAO,CAAC,CAAC,UAAAa,QAAA,UAAAA,QAAA,CAAI,CAAC,CAAC,CACjC,KAAM,CAAAG,SAAS,CAAGf,KAAK,CAACgB,IAAI,CAG5B,GAAI,CAAAC,aAAa,CAAG,KAAK,CACzB,GAAI,CAAAC,cAAkC,CACtCC,MAAM,CAACC,IAAI,CAACP,UAAU,CAAC,CAACQ,OAAO,CAAE,SAAAC,GAAG,CAAK,CACvC,KAAM,CAAAC,KAAK,CAAGT,SAAS,CAACQ,GAAG,CAAC,CAC5B,GAAI,CAACjB,UAAU,CAACkB,KAAK,CAAC,CAAE,CACtB,MAAO,CAAAV,UAAU,CAACS,GAAG,CAAC,CACxB,CACF,CAAC,CAAC,CACFH,MAAM,CAACC,IAAI,CAACN,SAAS,CAAC,CAACO,OAAO,CAAE,SAAAC,GAAG,CAAK,CACtC,KAAM,CAAAC,KAAK,CAAGT,SAAS,CAACQ,GAAG,CAAC,CAC5B,GAAIjB,UAAU,CAACkB,KAAK,CAAC,CAAE,CACrBL,cAAc,CAAGM,MAAM,CAACC,gBAAgB,EAAIC,WAAW,CAACC,GAAG,CAAC,CAAC,CAC7DrB,gBAAgB,CAACY,cAAc,CAAEK,KAAK,CAAEV,UAAU,CAACS,GAAG,CAAC,CAAEP,SAAS,CAACO,GAAG,CAAC,CAAC,CACxET,UAAU,CAACS,GAAG,CAAC,CAAGC,KAAK,CACvBN,aAAa,CAAG,IAAI,CACtB,CACF,CAAC,CAAC,CAEF,QAAS,CAAAW,KAAKA,CAACC,SAAoB,CAAE,CACnC,KAAM,CAAEhB,UAAU,CAAVA,UAAU,CAAEG,IAAI,CAAJA,IAAI,CAAEc,oBAAA,CAAAA,oBAAqB,CAAC,CAAG9B,KAAK,CACxD,GAAI8B,oBAAoB,CAAE,CACxB9B,KAAK,CAAC+B,kBAAkB,CAAG,KAAK,CAChC,OACF,CAEA,KAAM,CAAAC,OAA2B,CAAG,CAAC,CAAC,CACtC,GAAI,CAAAC,WAAW,CAAG,IAAI,CACtBd,MAAM,CAACC,IAAI,CAACP,UAAU,CAAC,CAACQ,OAAO,CAAE,SAAAa,QAAQ,CAAK,CAC5C,KAAM,CAAAC,QAAQ,CAAG5B,aAAa,CAC5BM,UAAU,CAACqB,QAAQ,CAAC,CACpBL,SAAS,CACTK,QAAQ,CACRF,OAAO,CACP9B,gBACF,CAAC,CACD,GAAIiC,QAAQ,CAAE,CACZnB,IAAI,CAACkB,QAAQ,CAAC,CAAGF,OAAO,CAACE,QAAQ,CAAC,CAClC,MAAO,CAAArB,UAAU,CAACqB,QAAQ,CAAC,CAC7B,CAAC,IAAM,CACLD,WAAW,CAAG,KAAK,CACrB,CACF,CAAC,CAAC,CAEF,GAAId,MAAM,CAACC,IAAI,CAACY,OAAO,CAAC,CAACI,MAAM,CAAE,CAC/B5B,sBAAsB,CACpBV,eAAe,CACfkC,OAAO,CACP/B,YAAY,CACZE,aAAa,CACbC,QACF,CAAC,CACH,CAEA,GAAI,CAAC6B,WAAW,CAAE,CAChBI,qBAAqB,CAACT,KAAK,CAAC,CAC9B,CAAC,IAAM,CACL5B,KAAK,CAAC+B,kBAAkB,CAAG,KAAK,CAClC,CACF,CAEA,GAAId,aAAa,CAAE,CACjBjB,KAAK,CAACa,UAAU,CAAGA,UAAU,CAC7B,GAAI,CAACb,KAAK,CAAC+B,kBAAkB,CAAE,CAC7B/B,KAAK,CAAC8B,oBAAoB,CAAG,KAAK,CAClC9B,KAAK,CAAC+B,kBAAkB,CAAG,IAAI,CAC/BH,KAAK,CAACV,cAAe,CAAC,CACxB,CACF,CAAC,IAAM,CACLlB,KAAK,CAAC8B,oBAAoB,CAAG,IAAI,CACjC9B,KAAK,CAACa,UAAU,CAAG,EAAE,CACvB,CAGAb,KAAK,CAACgB,IAAI,CAAGF,SAAS,CAEtB,GAAI,CAACL,YAAY,CAACM,SAAS,CAAED,SAAS,CAAC,CAAE,CACvCN,sBAAsB,CACpBV,eAAe,CACfgB,SAAS,CACTb,YAAY,CACZE,aAAa,CACbC,QACF,CAAC,CACH,CACF"}',
    version: "3.5.4"
};
var jestStyleUpdater = function() {
    var _e = [
        new global.Error(),
        -6,
        -27
    ];
    var jestStyleUpdater = function jestStyleUpdater(viewDescriptors, updater, state, maybeViewRef, animationsActive, animatedStyle) {
        var _state$animations2, _updater2;
        var adapters = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var animations = (_state$animations2 = state.animations) != null ? _state$animations2 : {};
        var newValues = (_updater2 = updater()) != null ? _updater2 : {};
        var oldValues = state.last;
        var hasAnimations = false;
        var frameTimestamp;
        Object.keys(animations).forEach(function(key) {
            var value = newValues[key];
            if (!(0, _utils.isAnimated)(value)) {
                delete animations[key];
            }
        });
        Object.keys(newValues).forEach(function(key) {
            var value = newValues[key];
            if ((0, _utils.isAnimated)(value)) {
                frameTimestamp = global.__frameTimestamp || performance.now();
                prepareAnimation(frameTimestamp, value, animations[key], oldValues[key]);
                animations[key] = value;
                hasAnimations = true;
            }
        });
        function frame(timestamp) {
            var animations = state.animations, last = state.last, isAnimationCancelled = state.isAnimationCancelled;
            if (isAnimationCancelled) {
                state.isAnimationRunning = false;
                return;
            }
            var updates = {};
            var allFinished = true;
            Object.keys(animations).forEach(function(propName) {
                var finished = runAnimations(animations[propName], timestamp, propName, updates, animationsActive);
                if (finished) {
                    last[propName] = updates[propName];
                    delete animations[propName];
                } else {
                    allFinished = false;
                }
            });
            if (Object.keys(updates).length) {
                (0, _UpdateProps.updatePropsJestWrapper)(viewDescriptors, updates, maybeViewRef, animatedStyle, adapters);
            }
            if (!allFinished) {
                requestAnimationFrame(frame);
            } else {
                state.isAnimationRunning = false;
            }
        }
        if (hasAnimations) {
            state.animations = animations;
            if (!state.isAnimationRunning) {
                state.isAnimationCancelled = false;
                state.isAnimationRunning = true;
                frame(frameTimestamp);
            }
        } else {
            state.isAnimationCancelled = true;
            state.animations = [];
        }
        state.last = newValues;
        if (!(0, _utils.shallowEqual)(oldValues, newValues)) {
            (0, _UpdateProps.updatePropsJestWrapper)(viewDescriptors, newValues, maybeViewRef, animatedStyle, adapters);
        }
    };
    jestStyleUpdater.__closure = {
        isAnimated: _utils.isAnimated,
        prepareAnimation: prepareAnimation,
        runAnimations: runAnimations,
        updatePropsJestWrapper: _UpdateProps.updatePropsJestWrapper,
        shallowEqual: _utils.shallowEqual
    };
    jestStyleUpdater.__initData = _worklet_9683044866140_init_data;
    jestStyleUpdater.__workletHash = 9683044866140;
    jestStyleUpdater.__stackDetails = _e;
    return jestStyleUpdater;
}();
function checkSharedValueUsage(prop, currentKey) {
    if (Array.isArray(prop)) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = prop[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                checkSharedValueUsage(element, currentKey);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else if (typeof prop === "object" && prop !== null && prop.value === undefined) {
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = Object.keys(prop)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var key = _step1.value;
                checkSharedValueUsage(prop[key], key);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    } else if (currentKey !== undefined && typeof prop === "object" && prop !== null && prop.value !== undefined) {
        throw new Error("[Reanimated] Invalid value passed to `".concat(currentKey, "`, maybe you forgot to use `.value`?"));
    }
}
var _worklet_6935660880873_init_data = {
    code: "function anonymous(){const{updater,adaptersArray}=this.__closure;const newValues=updater();adaptersArray.forEach(function(adapter){adapter(newValues);});return newValues;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedStyle.ts",
    sourceMap: '{"version":3,"names":["anonymous","updater","adaptersArray","__closure","newValues","forEach","adapter"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedStyle.ts"],"mappings":"AA4ckB,SAAAA,SAAMA,CAAA,QAAAC,OAAA,CAAAC,aAAA,OAAAC,SAAA,CAEhB,KAAM,CAAAC,SAAS,CAAGH,OAAO,CAAC,CAAC,CAC3BC,aAAa,CAACG,OAAO,CAAE,SAAAC,OAAO,CAAK,CAGjCA,OAAO,CAACF,SAAgB,CAAC,CAC3B,CAAC,CAAC,CACF,MAAO,CAAAA,SAAS,CAClB"}',
    version: "3.5.4"
};
var _worklet_16050463990619_init_data = {
    code: "function anonymous(){const{jestStyleUpdater,sharableViewDescriptors,updater,remoteState,maybeViewRef,animationsActive,animatedStyle,adaptersArray}=this.__closure;jestStyleUpdater(sharableViewDescriptors,updater,remoteState,maybeViewRef,animationsActive,animatedStyle,adaptersArray);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedStyle.ts",
    sourceMap: '{"version":3,"names":["anonymous","jestStyleUpdater","sharableViewDescriptors","updater","remoteState","maybeViewRef","animationsActive","animatedStyle","adaptersArray","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedStyle.ts"],"mappings":"AAydY,SAAAA,SAAMA,CAAA,QAAAC,gBAAA,CAAAC,uBAAA,CAAAC,OAAA,CAAAC,WAAA,CAAAC,YAAA,CAAAC,gBAAA,CAAAC,aAAA,CAAAC,aAAA,OAAAC,SAAA,CAEVR,gBAAgB,CACdC,uBAAuB,CACvBC,OAAO,CACPC,WAAW,CACXC,YAAY,CACZC,gBAAgB,CAChBC,aAAa,CACbC,aACF,CAAC,CACH"}',
    version: "3.5.4"
};
var _worklet_6409096485467_init_data = {
    code: "function anonymous(){const{styleUpdater,sharableViewDescriptors,updaterFn,remoteState,maybeViewRef,animationsActive,isAnimatedProps}=this.__closure;styleUpdater(sharableViewDescriptors,updaterFn,remoteState,maybeViewRef,animationsActive,isAnimatedProps);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedStyle.ts",
    sourceMap: '{"version":3,"names":["anonymous","styleUpdater","sharableViewDescriptors","updaterFn","remoteState","maybeViewRef","animationsActive","isAnimatedProps","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedStyle.ts"],"mappings":"AAseY,SAAAA,SAAMA,CAAA,QAAAC,YAAA,CAAAC,uBAAA,CAAAC,SAAA,CAAAC,WAAA,CAAAC,YAAA,CAAAC,gBAAA,CAAAC,eAAA,OAAAC,SAAA,CAEVP,YAAY,CACVC,uBAAuB,CACvBC,SAAS,CACTC,WAAW,CACXC,YAAY,CACZC,gBAAgB,CAChBC,eACF,CAAC,CACH"}',
    version: "3.5.4"
};
function useAnimatedStyle(updater, dependencies, adapters) {
    var _updater$__closure;
    var isAnimatedProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var viewsRef = (0, _ViewDescriptorsSet.makeViewsRefSet)();
    var initRef = (0, _react.useRef)();
    var inputs = Object.values((_updater$__closure = updater.__closure) != null ? _updater$__closure : {});
    if ((0, _PlatformChecker.shouldBeUseWeb)()) {
        var _dependencies;
        if (!inputs.length && (_dependencies = dependencies) != null && _dependencies.length) {
            inputs = dependencies;
        }
        if (__DEV__ && !inputs.length && !dependencies && !updater.__workletHash) {
            throw new Error("[Reanimated] `useAnimatedStyle` was used without a dependency array or Babel plugin. Please explicitly pass a dependency array, or enable the Babel/SWC plugin.\nFor more, see the docs: `https://docs.swmansion.com/react-native-reanimated/docs/guides/web-support#web-without-the-babel-plugin`.");
        }
    }
    var adaptersArray = adapters ? Array.isArray(adapters) ? adapters : [
        adapters
    ] : [];
    var adaptersHash = adapters ? (0, _utils.buildWorkletsHash)(adaptersArray) : null;
    var animationsActive = (0, _useSharedValue.useSharedValue)(true);
    var animatedStyle = (0, _react.useRef)({});
    if (!dependencies) {
        dependencies = [].concat((0, _toConsumableArray2.default)(inputs), [
            updater.__workletHash
        ]);
    } else {
        dependencies.push(updater.__workletHash);
    }
    adaptersHash && dependencies.push(adaptersHash);
    if (!initRef.current) {
        var initialStyle = (0, _animation.initialUpdaterRun)(updater);
        (0, _utils.validateAnimatedStyles)(initialStyle);
        initRef.current = {
            initial: {
                value: initialStyle,
                updater: updater
            },
            remoteState: (0, _core.makeRemote)({
                last: initialStyle,
                animations: {},
                isAnimationCancelled: false,
                isAnimationRunning: false
            }),
            viewDescriptors: (0, _ViewDescriptorsSet.makeViewDescriptorsSet)()
        };
    }
    var _initRef$current = initRef.current, initial = _initRef$current.initial, remoteState = _initRef$current.remoteState, viewDescriptors = _initRef$current.viewDescriptors;
    var sharableViewDescriptors = viewDescriptors.sharableViewDescriptors;
    var maybeViewRef = _NativeReanimated.default.native ? undefined : viewsRef;
    dependencies.push(sharableViewDescriptors);
    (0, _react.useEffect)(function() {
        var fun;
        var updaterFn = updater;
        if (adapters) {
            updaterFn = function() {
                var _e = [
                    new global.Error(),
                    -3,
                    -27
                ];
                var anonymous = function anonymous() {
                    var newValues = updater();
                    adaptersArray.forEach(function(adapter) {
                        adapter(newValues);
                    });
                    return newValues;
                };
                anonymous.__closure = {
                    updater: updater,
                    adaptersArray: adaptersArray
                };
                anonymous.__initData = _worklet_6935660880873_init_data;
                anonymous.__workletHash = 6935660880873;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        }
        if ((0, _PlatformChecker.isJest)()) {
            fun = function() {
                var _e = [
                    new global.Error(),
                    -9,
                    -27
                ];
                var anonymous = function anonymous() {
                    jestStyleUpdater(sharableViewDescriptors, updater, remoteState, maybeViewRef, animationsActive, animatedStyle, adaptersArray);
                };
                anonymous.__closure = {
                    jestStyleUpdater: jestStyleUpdater,
                    sharableViewDescriptors: sharableViewDescriptors,
                    updater: updater,
                    remoteState: remoteState,
                    maybeViewRef: maybeViewRef,
                    animationsActive: animationsActive,
                    animatedStyle: animatedStyle,
                    adaptersArray: adaptersArray
                };
                anonymous.__initData = _worklet_16050463990619_init_data;
                anonymous.__workletHash = 16050463990619;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        } else {
            fun = function() {
                var _e = [
                    new global.Error(),
                    -8,
                    -27
                ];
                var anonymous = function anonymous() {
                    styleUpdater(sharableViewDescriptors, updaterFn, remoteState, maybeViewRef, animationsActive, isAnimatedProps);
                };
                anonymous.__closure = {
                    styleUpdater: styleUpdater,
                    sharableViewDescriptors: sharableViewDescriptors,
                    updaterFn: updaterFn,
                    remoteState: remoteState,
                    maybeViewRef: maybeViewRef,
                    animationsActive: animationsActive,
                    isAnimatedProps: isAnimatedProps
                };
                anonymous.__initData = _worklet_6409096485467_init_data;
                anonymous.__workletHash = 6409096485467;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        }
        var mapperId = (0, _core.startMapper)(fun, inputs);
        return function() {
            (0, _core.stopMapper)(mapperId);
        };
    }, dependencies);
    (0, _react.useEffect)(function() {
        animationsActive.value = true;
        return function() {
            animationsActive.value = false;
        };
    }, []);
    checkSharedValueUsage(initial.value);
    if ((0, _PlatformChecker.isJest)()) {
        return {
            viewDescriptors: viewDescriptors,
            initial: initial,
            viewsRef: viewsRef,
            animatedStyle: animatedStyle
        };
    } else {
        return {
            viewDescriptors: viewDescriptors,
            initial: initial,
            viewsRef: viewsRef
        };
    }
}
